import iconTemplate from '~/components/icons/IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Ai-Sparkles--Streamline-Flex"
    >
        <desc>
            {'\n    Ai Sparkles Streamline Icon: https://streamlinehq.com\n  '}
        </desc>
        <g id="ai-sparkles--artificial-intelligence-ai-sparks-sparkles">
            <path
                id="Vector 2145"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.58731 2.59533C3.22779 1.95485 3.34824 0.75 3.61528 0.75s0.3875 1.20485 1.02797 1.84533c0.64048 0.64048 1.83737 0.70832 1.83737 1.02005 0 0.31174 -1.19689 0.37957 -1.83737 1.02005 -0.64047 0.64048 -0.76093 1.84533 -1.02797 1.84533s-0.38749 -1.20485 -1.02797 -1.84533S0.749939 3.92712 0.749939 3.61538c0 -0.31173 1.196891 -0.37957 1.837371 -1.02005"
                strokeWidth={1}
            />
            <path
                id="Vector 2145_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.6469 7.65836c0.92174 -0.92173 1.09509 -2.65567 1.47939 -2.65567 0.38431 0 0.55766 1.73394 1.47941 2.65567 0.9217 0.92174 2.6442 1.01936 2.6442 1.46799s-1.7225 0.54625 -2.6442 1.46795c-0.92175 0.9218 -1.0951 2.6557 -1.47941 2.6557 -0.3843 0 -0.55765 -1.7339 -1.47939 -2.6557 -0.92173 -0.9217 -2.64421 -1.01932 -2.64421 -1.46795S6.72517 8.5801 7.6469 7.65836"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
